import { Box, Stack } from '@mui/material'
import CattlesLogo from 'assets/CattlesLogo'
import { useWidgetDailyStatistics } from 'components/farm-dashboard/hooks/useWidgetDailyStatistics'
import { useWidgetPreview } from 'components/farm-dashboard/context/WidgetPreviewContext'
import { useEffect } from 'react'
import { fetchDailyStatistics } from 'store/cattlesSlice'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { BaseWidget } from '../../../baseWidget'

export const IdentificateWidget = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const dispatch = useAppDispatch()
	const { isPreview } = useWidgetPreview()
	const { dailyStatistics, loadingStatistics, error } =
		useWidgetDailyStatistics()

	useEffect(() => {
		if (isPreview) return
		!dailyStatistics && dispatch(fetchDailyStatistics('all'))
	}, [isPreview, dailyStatistics, dispatch])
	if (error || !permissions.license_identification) return null
	return (
		<BaseWidget
			icon={
				<Box
					sx={{
						width: '24px',
						height: '24px',
						backgroundColor: COLORS.mainSecondaryOpacity,
						borderRadius: '50%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<CattlesLogo color={COLORS.main} width={18} height={18} />
				</Box>
			}
			path={'/cattles'}
			isLoading={loadingStatistics}
		>
			<Stack direction='column' gap='8px'>
				<Stack direction='row' alignItems='center' gap='4px'>
					<TypographyPrimary16Bold>
						{dailyStatistics?.identified_count.value}
					</TypographyPrimary16Bold>
					<TypographySecondary>
						/{dailyStatistics?.identified_count.out_of}
					</TypographySecondary>
				</Stack>
				<TypographyPrimary>Оцифровано</TypographyPrimary>
			</Stack>
		</BaseWidget>
	)
}
